/**
 *  @class
 *  @function TabbedContent
 */
if (!customElements.get('tabbed-content')) {
  class TabbedContent extends HTMLElement {
    static get observedAttributes() {
      return ['selected-index'];
    }
    constructor() {
      super();
      this.scroller = this.querySelector('.tabbed-content__tabs');
      this.buttons = this.scroller.querySelectorAll('button');
      this.panels = this.querySelectorAll('.tab');
      this.activeClasses = this.dataset.activeClass.split(' ');
      this.regularClasses = this.dataset.regularClass.split(' ');
      this.tabsAdjustment();
      this.selectedIndex = this.selectedIndex;
      window.addEventListener('resize', this.tabsAdjustment.bind(this));
    }

    connectedCallback() {
      this.selectedIndex = this.selectedIndex;

      this.buttons.forEach((button, index) => {
        button.addEventListener('click', () => {
          this.selectedIndex = index;
        });
      });
      if (Shopify.designMode) {
        this.addEventListener('shopify:block:select', (event) => {
          this.selectedIndex = this.buttons.indexOf(event.target);
        });
      }
    }
    get selectedIndex() {
      return parseInt(this.getAttribute('selected-index')) || 0;
    }
    set selectedIndex(index) {
      this.setAttribute('selected-index', index);
    }
    attributeChangedCallback(name, oldValue, newValue) {
      if (name === 'selected-index' && oldValue !== null && oldValue !== newValue) {
        this.buttons[oldValue].classList.remove(...this.activeClasses);
        this.buttons[oldValue].classList.add(...this.regularClasses);
        this.buttons[newValue].classList.remove(...this.regularClasses);
        this.buttons[newValue].classList.add(...this.activeClasses);
        this.panels[parseInt(oldValue)].classList.remove('active');
        this.panels[parseInt(newValue)].classList.add('active');
      }
    }
    tabsAdjustment() {
      const buttonsWidth = Array.from(this.buttons).reduce((total, button) => (total += button.clientWidth), 0);

      if (buttonsWidth > this.scroller.clientWidth) {
        this.scroller.style.justifyContent = 'start';
      } else this.scroller.style.justifyContent = this.dataset.alignment;
    }
  }
  customElements.define('tabbed-content', TabbedContent);
}
